import * as React from 'react';

import * as styles from './styles.css';

/* istanbul ignore next */
export const TypingMessage = () => {
  return (
    <div data-testid="chat_message_typing" className={styles['loader-typing']}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
